import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74bdb462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-12" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "card-label" }, "Car Verification Details")
  ])
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "symbol symbol-150px" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img overlay-layer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-white" }, " image_search ")
], -1))
const _hoisted_7 = { style: {"min-width":"150px"} }
const _hoisted_8 = ["name", "id", "onUpdate:modelValue"]
const _hoisted_9 = ["for", "onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined fs-3 me-2 align-middle" }, " check_circle ", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Verify ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  class: "mt-6",
  style: {"min-width":"150px"}
}
const _hoisted_14 = ["name", "id", "onUpdate:modelValue"]
const _hoisted_15 = ["for", "onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined fs-3 me-2 align-middle" }, " block ", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Reject ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  class: "modal fade",
  tabindex: "-1",
  id: "modal"
}
const _hoisted_20 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_21 = { class: "modal-content bg-transparent shadow-none" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "d-flex justify-content-end" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_RejectForm = _resolveComponent("RejectForm")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass([$setup.tableData.length ? 'py-0' : 'pt-0', "card-body"])
      }, [
        _createVNode(_component_Datatable, {
          "table-header": $setup.tableHeader,
          "table-data": $setup.tableData,
          "enable-items-per-page-dropdown": false,
          loading: $setup.loading
        }, {
          "cell-kyc": _withCtx(({ row }) => [
            _createElementVNode("div", {
              class: "overlay cursor-pointer",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modal",
              onClick: ($event: any) => ($setup.changeImage(row.image))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: row.image,
                  alt: "Picture"
                }, null, 8, _hoisted_5),
                _hoisted_6
              ])
            ], 8, _hoisted_3)
          ]),
          "cell-title": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.title), 1)
          ]),
          "cell-details": _withCtx(({ row }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.details, (detail, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(detail), 1))
            }), 128))
          ]),
          "cell-status": _withCtx(({ row }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge px-8 py-3 fs-5", 
              row.verifyState === 'RejectVerify'
                ? 'badge-light-danger'
                : row.verifyState === 'WaitReviewVerify'
                ? 'badge-light-primary text-w-sky'
                : 'badge-light-success text-w-emerald px-9'
            ])
            }, _toDisplayString(row.verifyState === 'RejectVerify'
                ? 'Rejected'
                : row.verifyState === 'WaitReviewVerify'
                ? 'Pending'
                : 'Verified'), 3)
          ]),
          "cell-action": _withCtx(({ row, index }) => [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: `btn-radio-${index}`,
                id: `btn-radio-1-${index}`,
                "onUpdate:modelValue": ($event: any) => (($setup.tableData[index].verifyState) = $event),
                value: "Done"
              }, null, 8, _hoisted_8), [
                [_vModelRadio, $setup.tableData[index].verifyState]
              ]),
              _createElementVNode("label", {
                style: _normalizeStyle([{"padding-right":"1.85rem"}, row.verifyState === 'Done' && 'cursor: default']),
                class: "btn btn-light-success",
                for: `btn-radio-1-${index}`,
                onClick: ($event: any) => (
                row.verifyState !== 'Done' && $setup.verifyDocument('verify', row._id)
              )
              }, _hoisted_12, 12, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: `btn-radio-${index}`,
                id: `btn-radio-2-${index}`,
                "onUpdate:modelValue": ($event: any) => (($setup.tableData[index].verifyState) = $event),
                value: "RejectVerify"
              }, null, 8, _hoisted_14), [
                [_vModelRadio, $setup.tableData[index].verifyState]
              ]),
              _createElementVNode("label", {
                style: _normalizeStyle(row.verifyState === 'RejectVerify' && 'cursor: default'),
                class: "btn btn-light-danger",
                for: `btn-radio-2-${index}`,
                onClick: ($event: any) => (
                row.verifyState !== 'RejectVerify' &&
                  $setup.verifyDocument('reject', row._id)
              )
              }, _hoisted_18, 12, _hoisted_15)
            ])
          ]),
          _: 1
        }, 8, ["table-header", "table-data", "loading"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("img", {
            class: "figure-img img-fluid rounded m-0",
            src: $setup.currentImage,
            alt: "Image"
          }, null, 8, _hoisted_22)
        ])
      ])
    ]),
    _createVNode(_component_RejectForm, {
      disabled: !$setup.tableData.some((item) => item.verifyState === 'RejectVerify'),
      modelValue: $setup.rejectFormRef,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.rejectFormRef) = $event))
    }, null, 8, ["disabled", "modelValue"]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("button", {
        name: "confirm verification",
        class: _normalizeClass(["btn btn-primary py-4 px-20 fs-1 text-bold", 
        !$setup.tableData.some((item) => item.verifyState === 'RejectVerify')
          ? 'btn-primary'
          : 'btn-danger'
      ]),
        disabled: 
        !$setup.tableData.every((item) => item.verifyState !== 'WaitReviewVerify')
      ,
        "data-bs-toggle": "modal",
        "data-bs-target": "#confirm"
      }, _toDisplayString(!$setup.tableData.some((item) => item.verifyState === 'RejectVerify')
          ? 'Approve'
          : 'Reject'), 11, _hoisted_24)
    ]),
    _createVNode(_component_ConfirmModal, { ref: "modalRef" }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          name: "confirm",
          class: "btn btn-primary px-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
        !$setup.tableData.some((item) => item.verifyState === 'RejectVerify')
          ? $setup.verifyCar('approve')
          : $setup.verifyCar('reject')
      ))
        }, " Confirm ")
      ]),
      _: 1
    }, 512)
  ], 64))
}